import { PieChart, Pie, Sector, Cell, ResponsiveContainer,Tooltip, Legend } from 'recharts'

const Outgoingpiechart = ({out,ins}:{out:number,ins:number}) => {
  const data = [
    { name: 'outgoing transaction', value: parseFloat(out.toFixed(2)), fill: "#FF5300",label:"out"  },
    { name: 'incoming transaction', value: parseFloat(ins.toFixed(2)), fill: "#41134a",label:"in" },
  ];
  const COLORS = [ "#41134a","#FF5300",];
  return (
    <>
    <ResponsiveContainer width="100%" height={200}>  
    <PieChart
      height={200}
      width={300}
    >
      <Pie
        data={data}
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index.toString()}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>
      <Tooltip />
      <Legend height={18} />
    </PieChart>

  </ResponsiveContainer>
    </>
   
  )
}

export default Outgoingpiechart

